export default __webpack_public_path__ + "static/media/pantry1-afterC-768w.9ac128a6.avif";